import client from './client';

// ==================== Scenario Templates ====================

export const listTemplates = async () => {
  const response = await client.get('/api/scenarios/templates');
  return response.data;
};

export const createTemplate = async (templateData) => {
  const response = await client.post('/api/scenarios/templates', templateData);
  return response.data;
};

export const getTemplate = async (templateId) => {
  const response = await client.get(`/api/scenarios/templates/${templateId}`);
  return response.data;
};

export const updateTemplate = async (templateId, templateData) => {
  const response = await client.put(`/api/scenarios/templates/${templateId}`, templateData);
  return response.data;
};

export const deleteTemplate = async (templateId) => {
  const response = await client.delete(`/api/scenarios/templates/${templateId}`);
  return response.data;
};

export const duplicateTemplate = async (templateId) => {
  const response = await client.post(`/api/scenarios/templates/${templateId}/duplicate`);
  return response.data;
};

// ==================== Pipeline Scenarios ====================

export const listPipelineScenarios = async (pipelineId) => {
  const response = await client.get(`/api/pipelines/${pipelineId}/scenarios`);
  return response.data;
};

export const createPipelineScenario = async (pipelineId, scenarioData) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/scenarios`, scenarioData);
  return response.data;
};

export const createScenarioFromTemplate = async (pipelineId, data) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/scenarios/from-template`, data);
  return response.data;
};

export const getPipelineScenario = async (pipelineId, scenarioId) => {
  const response = await client.get(`/api/pipelines/${pipelineId}/scenarios/${scenarioId}`);
  return response.data;
};

export const updatePipelineScenario = async (pipelineId, scenarioId, scenarioData) => {
  const response = await client.put(`/api/pipelines/${pipelineId}/scenarios/${scenarioId}`, scenarioData);
  return response.data;
};

export const deletePipelineScenario = async (pipelineId, scenarioId) => {
  const response = await client.delete(`/api/pipelines/${pipelineId}/scenarios/${scenarioId}`);
  return response.data;
};

export const activateScenario = async (pipelineId, scenarioId) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/scenarios/${scenarioId}/activate`);
  return response.data;
};

export const deactivateScenario = async (pipelineId, scenarioId) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/scenarios/${scenarioId}/deactivate`);
  return response.data;
};

// ==================== Channel Targets ====================

export const listPipelineChannelTargets = async (pipelineId) => {
  const response = await client.get(`/api/pipelines/${pipelineId}/channel-targets`);
  return response.data;
};

export const addPipelineChannelTarget = async (pipelineId, targetData) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/channel-targets`, targetData);
  return response.data;
};

export const listScenarioChannelTargets = async (scenarioId) => {
  const response = await client.get(`/api/scenarios/${scenarioId}/channel-targets`);
  return response.data;
};

export const addScenarioChannelTarget = async (scenarioId, targetData) => {
  const response = await client.post(`/api/scenarios/${scenarioId}/channel-targets`, targetData);
  return response.data;
};

export const updateChannelTarget = async (targetId, targetData) => {
  const response = await client.put(`/api/channel-targets/${targetId}`, targetData);
  return response.data;
};

export const deleteChannelTarget = async (targetId) => {
  const response = await client.delete(`/api/channel-targets/${targetId}`);
  return response.data;
};

export default {
  // Templates
  listTemplates,
  createTemplate,
  getTemplate,
  updateTemplate,
  deleteTemplate,
  duplicateTemplate,
  // Pipeline Scenarios
  listPipelineScenarios,
  createPipelineScenario,
  createScenarioFromTemplate,
  getPipelineScenario,
  updatePipelineScenario,
  deletePipelineScenario,
  activateScenario,
  deactivateScenario,
  // Channel Targets
  listPipelineChannelTargets,
  addPipelineChannelTarget,
  listScenarioChannelTargets,
  addScenarioChannelTarget,
  updateChannelTarget,
  deleteChannelTarget,
};
